module.exports = __webpack_public_path__ + "static/media/fone-highlight.97c764ee.svg";